<template>
  <model :feature-list="featureList" :page-data="pageData"></model>
</template>

<script>
import model from './model.vue'

export default {
  components: {
    model
  },
  data () {
    return {
      pageData: {
        overview: {
          label: '档案智能著录概览',
          title: '减少重复整理，让档案信息提取与核验更高效',
          description: '辅助处理电子文件和件组信息，提取关键内容并把需要人工判断的环节集中呈现。',
          tags: ['内容提取', '件组整理', '字段补全', '人工核验'],
          panel: {
            title: '智能著录工作台',
            summaryLabel: '待处理电子文件',
            summaryValue: '268 件',
            rows: [
              { label: '内容识别', value: '241 件已完成', tone: 'positive' },
              { label: '件组信息', value: '86% 已完成', tone: 'positive' },
              { label: '人工核验', value: '27 件待处理', tone: 'warning' },
              { label: '著录字段', value: '12 项已补全', tone: 'primary' }
            ],
            footer: '机器提取结果与人工核验进度清晰分离'
          },
          values: [
            { title: '内容提取', description: '快速获取题名、时间、人物、地点等信息。' },
            { title: '标准统一', description: '以统一字段和规则减少信息质量差异。' },
            { title: '聚焦判断', description: '减少重复录入，专注核验与信息完善。' }
          ]
        },
        featureSection: {
          title: '让档案信息整理更加高效有序',
          description: '从电子文件处理到件组信息核验，为档案著录提供清晰、连续的辅助能力。'
        },
        process: {
          title: '建立清晰的智能著录流程',
          description: '让电子文件在导入、整理、核验过程中逐步形成规范的档案信息。',
          steps: [
            { title: '导入电子文件', description: '将待处理电子文件统一归集至著录任务。' },
            { title: '筛选与整理', description: '完成文件筛选、删除、修改等基础处理。' },
            { title: '补全件组信息', description: '整理标题、时间、人物、地点和内容等信息。' },
            { title: '核验并归档', description: '确认著录信息后形成规范的档案数据。' }
          ]
        }
      },
      featureList: [
        {
          feature: '文件处理、件组整理与信息核验',
          description: [
            '支持已上传电子文件的筛选、删除和修改，减少重复处理工作。',
            '支持整理标题、时间、拍摄者、人物、地点和内容等件组信息，辅助完善档案著录。'
          ],
          src2: require('../../assets/images/solution-img-5.jpeg')
        }
      ]
    }
  }
}
</script>
